/*
 * @Author: huangzq
 * @Date: 2020-04-01 16:05:59
 * @Last Modified by: huangzq
 * @Last Modified time: 2021-03-05 13:59:14
 * @Desc: 营销视频-对应的编辑组件
*/
<template>
  <div
    v-loading="loading"
    class="editor-components"
  >
    <template v-if="!loading">
      <div class="center-content">
        <p class="editor-title">
          营销视频设置
        </p>
        <mk-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="110px"
          class="editor-form"
        >
          <mk-form-item
            label="视频标题："
            prop="title"
          >
            <mk-input
              v-model="formData.title"
              width="370"
              maxlength="20"
              placeholder="请输入视频标题"
              show-word-limit
            />
          </mk-form-item>

          <mk-form-item
            label="视频摘要："
            prop="summary"
          >
            <mk-input
              v-model="formData.summary"
              type="textarea"
              resize="none"
              width="370"
              height="60"
              maxlength="50"
              placeholder="请输入视频摘要"
              show-word-limit
            />
          </mk-form-item>

          <!-- prop="cover" -->
          <mk-form-item
            label="视频封面："
          >
            <mk-upload-oss-biz
              :bucket="$env.VUE_APP_ALI_OSS_BUCKET"
              :disabled="imagesLoading"
              :limit-size="2"
              accept=".png,.jpg"
              no-accept-msg="仅支持jpg/png格式"
              @on-upload="imageUpload"
            >
              <mk-image
                v-loading="imagesLoading"
                :src="formData.cover"
                class="cover-img"
                fit="cover"
              />
              <span class="chenge-cover">更换封面</span>
            </mk-upload-oss-biz>
            <p class="cover-upload-tip">
              只能上传jpg/png文件，不超过2M
            </p>
          </mk-form-item>

          <mk-form-item label="打标签规则：">
            <tag-rules
              ref="tagRules"
              :key="formData.key"
              v-model="formData.rules"
              :rules-data="formData"
              :type="type"
            />
          </mk-form-item>

          <mk-form-item label="添加关联内容：">
            <template v-if="existExtraInfo">
              <div class="extraInfo-title-wrapper">
                <p>{{ formData.extraInfo.title }}</p>
                <span
                  class="delete-span cursor"
                  @click="deleteExtraInfo"
                >删除</span>
              </div>
            </template>
            <mk-popover
              v-else
              placement="bottom-start"
              trigger="hover"
              popper-class="relation-popover"
            >
              <template slot="reference">
                <div class="add-relation-btn">
                  <i class="el-icon-plus"></i>
                  <span>添加</span>
                </div>
                <!-- <mk-button>添加</mk-button> -->
              </template>

              <ul class="relation-popover-ul">
                <li
                  class="ul-item"
                  @click="addRelationFun('materials')"
                >
                  <div class="icon-div">
                    <mk-iconfont icon-class="tianjiaziliao" />
                  </div>
                  <span>添加资料</span>
                </li>
                <li
                  class="ul-item"
                  @click="addRelationFun('goods')"
                >
                  <div class="icon-div">
                    <mk-iconfont icon-class="tianjiashangpin" />
                  </div>
                  <span>添加商品</span>
                </li>
              </ul>
            </mk-popover>
          </mk-form-item>

          <mk-form-item
            v-if="existExtraInfo"
            label="描述文案："
          >
            <mk-input
              v-model="formData.extraInfo.desc"
              type="textarea"
              resize="none"
              width="370"
              height="60"
              maxlength="30"
              placeholder="请输入描述文案"
              show-word-limit
            />
          </mk-form-item>
        </mk-form>
      </div>

      <!-- 底部按钮栏 -->
      <div class="buttom-op-line">
        <mk-button
          width="64px"
          size="small"
          @click="goBack"
        >
          返回
        </mk-button>
        <mk-button
          width="64px"
          size="small"
          @click="checkForm('Preview')"
        >
          预览
        </mk-button>
        <mk-button
          :loading="confirmBtnLoading"
          type="primary"
          width="64px"
          size="small"
          @click="checkForm('Comfirm')"
        >
          提交
        </mk-button>
      </div>

      <!-- 关联内容弹窗区域 -->
      <!-- 关联资料、商品公用弹窗 -->
      <materials-goods-dialog
        :visible.sync="isShowMaterialsGoodsRelationDialog"
        :title="relationDialogTitle"
        :type="relationDialogType"
        @on-confirm="handelMaterialsRelationDialogOnComfirm"
      />

      <!-- 预览弹窗区域 -->
      <priview-dialog
        :visible.sync="isShowPreviewDialog"
        :material-data="formData"
      />
    </template>
  </div>
</template>

<script>
import TagRules from '@components/tag-rules'

import MaterialsGoodsDialog from './materials-goods-dialog'
import PriviewDialog from './priview-dialog'

export default {
  name: 'EditorComponents',
  components: { TagRules, MaterialsGoodsDialog, PriviewDialog },
  props: {
    // 当前资料类型
    type: {
      type: String,
      default: 'video-markting'
    },
    // 其他接口promise：新建、更新、查询等
    api: {
      type: Object,
      default () {
        return {
          create: MKMATERIALSVC.VideoApi.videoCreatePost,
          update: MKMATERIALSVC.VideoApi.videoCreatePost,
          find: MKMATERIALSVC.VideoApi.videoDetailGet
        }
      }
    }
  },
  data () {
    return {
      // 营销视频id
      materialId: '',
      // 表单数据
      formData: {},
      // 表单规则
      formRules: {
        title: [
          { required: true, message: '请输入视频标题', trigger: 'blur' }
        ]
        // cover: [
        //   { required: true, message: '请上传封面图片', trigger: 'change' }
        // ]
      },
      // 页面加载中
      loading: true,
      // 图片是否正在上传
      imagesLoading: false,
      // 提交按钮loading
      confirmBtnLoading: false,

      // 关联弹窗类型：materials(资料)、goods(商品)
      relationDialogType: '',

      relationDialogTypeMap: {
        materials: '资料',
        goods: '商品'
      },

      // 关联弹窗的title
      relationDialogTitle: '添加资料',

      // 是否显示营销资料、商品关联弹窗
      isShowMaterialsGoodsRelationDialog: false,

      // 是否显示预览弹窗
      isShowPreviewDialog: false
    }
  },
  computed: {
    // 是否存在 已关联的内容
    existExtraInfo () {
      return this.formData.extraInfo && this.formData.extraInfo._id
    }
  },
  activated () {
    this.materialId = this.$route.query._id
    if (this.materialId) this.getFormDataByApi()
    else this.initFormData()
  },
  deactivated () {
    window.sessionStorage.setItem('MarketingMterialTabName', this.type)
  },
  methods: {
    // 初始化表单数据
    async initFormData (data = null) {
      if (data) this.formData = this._.cloneDeep(data)
      else {
        this.formData = {
          title: '',
          summary: '',
          rules: [],
          cover: window.sessionStorage.getItem('video-markting-cover'),
          status: 0,
          extraInfo: {
            _id: '',
            type: '',
            title: '',
            desc: ''
          },
          url: window.sessionStorage.getItem('video-markting-url')
        }
      }
      this.loading = false

      // 获取视频时长-格式化后的
      const { formatDuration } = await this.util.getVideoDuration(this.formData.url)

      this.formData.duration = formatDuration

      const { rules } = this.formData
    },

    // 通过接口获取数据，当存在_id时，才执行
    async getFormDataByApi () {
      const res = await this.api.find({ _id: this.materialId })
      if (res.success) {
        this.initFormData(res.data)
      } else {
      }
    },

    // 图片上传事件
    imageUpload (res) {
      if (res.type === 'fail') {
        this.$message.error('上传失败')
        this.imagesLoading = false
      } else if (res.type === 'success') {
        this.imagesLoading = false
        this.formData.cover = res.result.url
      } else if (res.type === 'before') {
        this.imagesLoading = true
      } else if (res.type === 'progress') {
        this.imagesLoading = true
      }
    },

    // 添加关联内容事件
    addRelationFun (type) {
      this.relationDialogType = type

      this.relationDialogTitle = `添加${this.relationDialogTypeMap[this.relationDialogType]}`

      this.isShowMaterialsGoodsRelationDialog = true
    },

    // 返回事件
    goBack () {
      this.$confirm('内容将不会被保存', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        this.toMarketingData()
      }).catch(() => {})
    },

    // 验证表单必填
    checkForm (methods) {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (methods === 'Comfirm') {
            if (this.$refs.tagRules.doCheck()) {
              this[`on${methods}`]()
            }
          } else {
            this[`on${methods}`]()
          }
        }
      })
    },

    // 预览事件
    onPreview () {
      this.isShowPreviewDialog = true
    },

    // 关联营销资料弹窗-确认事件
    handelMaterialsRelationDialogOnComfirm ({ _id, type, item }) {
      this.formData.extraInfo = {
        _id,
        type,
        title: `${this.relationDialogTypeMap[this.relationDialogType]}-${item.title}`,
        desc: item.title
      }

      this.isShowMaterialsGoodsRelationDialog = false
    },

    // 删除关联内容
    deleteExtraInfo () {
      this.formData.extraInfo = {
        _id: '',
        type: '',
        title: '',
        desc: ''
      }
    },

    // 提交事件
    async onComfirm () {
      this.confirmBtnLoading = true
      const res = await this.api.update(this.formData)
      if (res.success) {
        this.confirmBtnLoading = false
        this.$message.success('保存成功')
        this.toMarketingData()
      } else {
      }
    },

    // 跳转到营销视频列表页面
    toMarketingData () {
      window.sessionStorage.setItem('MarketingMterialTabName', this.type)
      this.$router.push({
        path: '/marketing-content/marketing-data'
      })
    }
  }
}
</script>

<style lang='scss'>
body {
  .editor-components {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .center-content {
      flex: 1;
      padding: 30px;
      overflow: auto;

      .editor-title {
        padding-left: 8px;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 500;
        border-left: 4px solid #009cff;
      }

      .editor-form {
        .el-form-item {
          .el-upload--text {
            display: flex;
            align-items: flex-end;
            width: 140px;

            .cover-img {
              width: 60px;
              height: 60px;
              margin-right: 14px;
              border-radius: 4px;

              img {
                display: block;
              }
            }

            .chenge-cover {
              font-size: 13px;
              color: #009cff;
              line-height: 18px;
            }
          }

          .cover-upload-tip {
            margin-top: 12px;
            font-size: 12px;
            color: #8c8c8c;
            line-height: normal;
          }

          .add-relation-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 83px;
            height: 32px;
            line-height: 32px;
            margin-top: 4px;
            color: #1b9aee;
            font-size: 14px;
            border-radius: 4px;
            border: 1px solid #ccecff;
            box-sizing: border-box;

            @extend .cursor;

            &:hover {
              color: #0054d8;
              background-color: #edf7ff;
            }

            .el-icon-plus {
              margin-right: 10px;
              font-size: 14px;
            }
          }

          .extraInfo-title-wrapper {
            display: flex;
            font-size: 13px;
            color: #595959;

            .delete-span {
              margin-left: 15px;
              color: #009cff;
            }
          }

          // 文本域输入框的字数限制：更改它的行高
          .el-input__count {
            line-height: normal;
          }
        }
      }
    }

    .buttom-op-line {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    }
  }

  .relation-popover {
    padding: 0;
    border: none;

    .relation-popover-ul {
      display: flex;
      justify-content: space-between;
      width: 220px;
      padding: 22px 30px 15px;
      box-sizing: border-box;

      .ul-item {
        width: 52px;
        text-align: center;

        @extend .cursor;

        &:hover {
          .icon-div {
            background-color: #e8f6ff;

            .iconfont {
              color: #009cff;
            }
          }

          span {
            color: #009cff;
          }
        }

        .icon-div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          margin: 0 auto 6px;
          background-color: #f6f6f6;
          border-radius: 6px;

          .iconfont {
            font-size: 26px;
            color: #dcdcdc;
          }
        }

        span {
          font-size: 13px;
          color: #595959;
        }
      }
    }
  }
}

</style>
